import { Outlet, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import MobileStickyCTA from "@/components/feature/MobileStickyCTA";
import WhatsAppFloat from "@/components/feature/WhatsAppFloat";
import CartDrawer from "@/components/feature/CartDrawer";

export default function Layout() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 800);
    return () => clearTimeout(timer);
  }, []);

  useEffect(() => {
    if (location.hash) {
      const id = location.hash.replace("#", "");
      setTimeout(() => {
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: "smooth" });
        }
      }, 150);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="min-h-screen bg-background-50 text-foreground-950 font-sans">
      <AnimatePresence>
        {loading && (
          <motion.div
            key="loader"
            initial={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
            className="fixed inset-0 z-[9999] flex items-center justify-center bg-background-50"
          >
            <motion.div
              animate={{ rotate: 360 }}
              transition={{ duration: 1.2, repeat: Infinity, ease: "linear" }}
              className="w-10 h-10 rounded-full border-2 border-primary-500 border-t-transparent"
            />
          </motion.div>
        )}
      </AnimatePresence>

      <Navbar />
      <main className="pb-24 lg:pb-0">
        <Outlet />
      </main>
      <Footer />
      <MobileStickyCTA />
      <WhatsAppFloat />
      <CartDrawer />
    </div>
  );
}